import { render, staticRenderFns } from "./main.devolucionesFactura.vue?vue&type=template&id=ad660848"
import script from "./main.devolucionesFactura.vue?vue&type=script&lang=js"
export * from "./main.devolucionesFactura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports